import axios from 'axios';
import { store } from 'plugins/store/store';
import { setLicenseSettingsActionCreator } from '../plugins/store/reducers/settings.reducer';

const API_URL = '/api/v1/license/';
const UPDATE = 'update';

const setLicenseSettings = (value) => {
	store.dispatch(setLicenseSettingsActionCreator(value));
}

const getLicenseSettings = async () => {
	try {
		const licenseInfo = await axios.get(API_URL);
		setLicenseSettings(licenseInfo);
		return licenseInfo;
	} catch (error) {
		setLicenseSettings(null);
		throw error;
	}
};

const updateLicenseSettings = async () => {
	try {
		const licenseInfo = await axios.get(`${API_URL}${UPDATE}`);
		setLicenseSettings(licenseInfo);
		return licenseInfo;
	} catch (error) {
		setLicenseSettings(null);
		throw error;
	}
};

export {
	getLicenseSettings,
	updateLicenseSettings,
};
